import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(formData) {
    return axios.post(api.path("support.tickets"), formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}

export function index() {
    return axios.get(api.path("support.tickets"));
}

export function show(ticketId) {
    return axios.get(api.path("support.ticket", { ticketId: ticketId }));
}

